module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Filter-31d98520f062e3f81e7e589933694fad7319d533db402a06db512d1b64975860.svg";